import { OnboardingV2State, OnboardingV2Action } from './types.ts';
import * as actions from './actions.ts';
import * as actionTypes from '../actions/types.js';

const INITIAL_STATE: OnboardingV2State = {
  currentStep: 1,
  isLoading: false,
  error: null,
  
  accountType: null,
  personaForm: {
    name: '',
    lastName: '',
    tel: '',
    webSite: '',
    bio: '',
    facebook: '',
    linkedin: '',
    twitter: '',
    instagram: '',
  },
  empresaForm: {
    companyName: '',
    tel: '',
    webSite: '',
    bio: '',
    facebook: '',
    linkedin: '',
    twitter: '',
    instagram: '',
  },
  userSkills: [],
  workZones: [],
  allCountry: false,
  workCoverageKind: 'specificZones',
  influenceLat: null,
  influenceLng: null,
  influenceRadiusKm: 50,
  influencePlaceLabel: null,
  userImage: null,
  
  isFromSkipOnboarding: false,
  isCompleted: false,
  
  skills: [],
  skillCategories: [],
  selectedCategoryFilter: null,
  preferredProfileCategories: [],
  cities: [],
};

export const onboardingV2Reducer = (
  state: OnboardingV2State = INITIAL_STATE,
  action: OnboardingV2Action
): OnboardingV2State => {
  switch (action.type) {
    case actions.ONBOARDING_V2_SET_STEP:
      return {
        ...state,
        currentStep: action.payload,
      };
    
    case actions.ONBOARDING_V2_SET_ACCOUNT_TYPE:
      return {
        ...state,
        accountType: action.payload,
      };
    
    case actions.ONBOARDING_V2_SET_PERSONA_FORM:
      return {
        ...state,
        personaForm: action.payload,
      };
    
    case actions.ONBOARDING_V2_SET_EMPRESA_FORM:
      return {
        ...state,
        empresaForm: action.payload,
      };
    
    case actions.ONBOARDING_V2_SET_USER_SKILLS:
      return {
        ...state,
        userSkills: action.payload,
      };
    
    case actions.ONBOARDING_V2_ADD_SKILL:
      if (state.userSkills.find(s => s.id === action.payload.id)) {
        return state;
      }
      return {
        ...state,
        userSkills: [...state.userSkills, action.payload],
      };
    
    case actions.ONBOARDING_V2_REMOVE_SKILL:
      return {
        ...state,
        userSkills: state.userSkills.filter(s => s.id !== action.payload),
      };
    
    case actions.ONBOARDING_V2_SET_WORK_ZONES:
      return {
        ...state,
        workZones: action.payload,
      };
    
    case actions.ONBOARDING_V2_SET_ALL_COUNTRY:
      return {
        ...state,
        allCountry: action.payload,
      };

    case actions.ONBOARDING_V2_SET_WORK_COVERAGE_KIND:
      return {
        ...state,
        workCoverageKind: action.payload,
      };

    case actions.ONBOARDING_V2_SET_INFLUENCE_MAP: {
      const p = action.payload as {
        lat?: number | null;
        lng?: number | null;
        radiusKm?: number;
        placeLabel?: string | null;
      };
      return {
        ...state,
        influenceLat: p.lat !== undefined ? p.lat : state.influenceLat,
        influenceLng: p.lng !== undefined ? p.lng : state.influenceLng,
        influenceRadiusKm: p.radiusKm !== undefined ? p.radiusKm : state.influenceRadiusKm,
        influencePlaceLabel: p.placeLabel !== undefined ? p.placeLabel : state.influencePlaceLabel,
      };
    }
    
    case actions.ONBOARDING_V2_SET_USER_IMAGE:
      return {
        ...state,
        userImage: action.payload,
      };
    
    case actions.ONBOARDING_V2_SET_FROM_SKIP:
      return {
        ...state,
        isFromSkipOnboarding: action.payload,
      };
    
    case actions.ONBOARDING_V2_GET_SKILLS_START:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    
    case actions.ONBOARDING_V2_GET_SKILLS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        skills: action.payload,
      };
    
    case actions.ONBOARDING_V2_GET_SKILLS_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    
    case actions.ONBOARDING_V2_SET_SKILL_CATEGORIES:
      return {
        ...state,
        skillCategories: action.payload,
      };
    
    case actions.ONBOARDING_V2_SET_SELECTED_CATEGORY_FILTER:
      return {
        ...state,
        selectedCategoryFilter: action.payload,
      };
    
    case actions.ONBOARDING_V2_SET_PREFERRED_PROFILE_CATEGORIES:
      return {
        ...state,
        preferredProfileCategories: action.payload,
      };
    
    case actions.ONBOARDING_V2_GET_CITIES_START:
      return {
        ...state,
        isLoading: true,
        error: null,
        cities: [],
      };
    
    case actions.ONBOARDING_V2_GET_CITIES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        cities: action.payload,
      };
    
    case actions.ONBOARDING_V2_GET_CITIES_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    
    case actions.ONBOARDING_V2_UPDATE_PROFILE_START:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    
    case actions.ONBOARDING_V2_UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isCompleted: true,
      };
    
    case actions.ONBOARDING_V2_UPDATE_PROFILE_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    
    case actions.ONBOARDING_V2_RESET:
      return INITIAL_STATE;
    
    case actionTypes.LOGOUT:
      return INITIAL_STATE;
    
    default:
      return state;
  }
};
